<template lang="pug">
.v-big-slider.big-slider(v-if="slides")
	.big-slider__slider-wrapper
		button.big-slider__arrow.big-slider__arrow--prev(type="button" ref="slides-prev" aria-label="Предыдущий слайд")
			v-svg-icon.big-slider__arrow-icon(icon="slide-left")
			v-svg-icon.big-slider__arrow-bg(icon="slide-left-bg")
		button.big-slider__arrow.big-slider__arrow--next(type="button" ref="slides-next" aria-label="Следующий слайд")
			v-svg-icon.big-slider__arrow-icon(icon="slide-right")
			v-svg-icon.big-slider__arrow-bg(icon="slide-right-bg")
		v-swiper-slider.big-slider__slider(:options="options"
				:navigation="navigation"
				:pagination="pagination"
				@swiper="onSwiper")
			swiper-slide.big-slider__slide(v-if="slides && slides.length"
					v-for="(slide, slideIndex) in slides"
					:key="slideIndex")
				img.big-slider__item-background(:src="slide" alt="" loading="lazy")
				img.big-slider__item(:src="slide" alt="" loading="lazy")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import {SwiperSlide} from 'swiper/vue';

export default {
	mixins: [
		sourceMixin
	],

	components: {
		SwiperSlide
	},

	data() {
		return {
			slides: null,
			options: {
				spaceBetween: 8,
				slidesPerView: 1,
			},
			allowTouchMove: true,
			pagination: {
				clickable: false
			},
			navigation: false
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['slides-prev'],
				nextEl: this.$refs['slides-next']
			};
		},
		
		dataSet(data) {
			this.slides = data;
		},
	}
};
</script>